import './unsubscribe-page.scss';
import React from 'react';
import ADDLogo from '@svg/dd-logo.svg?react';
import CircleErrorIcon from '@svg/circle-error.svg?react';

/**
 * Public SPA page shown when the one-click email unsubscribe flow fails.
 *
 * Rendered after a redirect from UnsubscribePage on API error or missing token.
 * No authentication is required — this page is accessible without a session.
 */
export const UnsubscribeFailedPage: React.FC = () => {
    return (
        <div className="unsubscribe-container">
            <div className="unsubscribe-logo">
                <ADDLogo />
            </div>
            <CircleErrorIcon />
            <div className="title">Unable to unsubscribe</div>
            <div className="sub-title">
                Your subscription to AT&T Dynamic Defense Executive Summary report emails couldn't be updated.
            </div>
            <div className="sub-title">
                To manage your subscription settings visit{' '}
                <a href="/" className="portal-link">Dynamic Defense</a>
            </div>
        </div>
    );
};
